import { render, staticRenderFns } from "./CoreValue.vue?vue&type=template&id=889ee0ba&"
import script from "./CoreValue.vue?vue&type=script&lang=js&"
export * from "./CoreValue.vue?vue&type=script&lang=js&"
import style0 from "./CoreValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports